<template>
  <div
    class="m-inline-search"
    @keydown.stop="$emit('handle-click-navigation', $event)"
  >
    <input
      :id="inputId"
      ref="input"
      class="m-inline-search__input"
      :placeholder="placeholder"
      :value="value"
      type="text"
      @input="input($event)"
      @change="change($event)"
      @focus="$emit('focus', true)"
      @blur="$emit('focus', false)"
    >
    <MIcon
      class="m-inline-search__icon"
      :icon="icon"
    />
  </div>
</template>

<script>
  import _ from 'lodash';

  _.noConflict();

  import MIcon from 'components/Design/MIcon';
  import SearchIcon from 'assets/icons/search.svg';

  export default {
    name: 'MSearchInline',
    components: {MIcon},
    props: {
      placeholder: {
        type: String,
        default: undefined
      },
      icon: {
        type: Object,
        default: () => SearchIcon
      },
      value: {
        type: String,
        default: ''
      },
      emitInputOnChange: {
        type: Boolean,
        default: true
      },
      isDebounced: {
        type: Boolean,
        default: true
      },
      inputId: {
        type: String,
        default: ''
      }
    },
    mounted () {
      this.setFocus();
    },
    methods: {
      setFocus () {
        this.$refs.input.focus({preventScroll: true});
      },
      emitInput (value) {
        this.$emit('input', value);
      },
      debouncedEmitInput: _.debounce(function (value) {
        this.emitInput(value);
      }, 500),
      onInput (val) {
        if (this.isDebounced){
          return this.debouncedEmitInput(val);
        }
        return this.emitInput(val);
      },
      input (e) {
        if (this.emitInputOnChange) {
          return;
        }
        return this.onInput(e.target.value);
      },
      change (e) {
        if (this.emitInputOnChange) {
          return this.emitInput(e.target.value);
        }
      }
    }
  };
</script>

<style>
  .m-inline-search {
    /* constants. Can be change outside */
    --border-idle-color: var(--border-color);
    --border-focused-color: var(--action-color);

    /* variables. Shouldn't be changed outside */
    --current-border-color: var(--border-idle-color);
    --border-transition: border linear 200ms, box-shadow linear 200ms;
    --search-icon-color: #4F4F4F;

    display: flex;

    flex-wrap: nowrap;
    align-items: flex-end;

    background-color: var(--background-color);
  }

  /* stylelint-disable-next-line selector-no-qualifying-type */
  .m-inline-search input[type='text'].m-inline-search__input {
    font-size: var(--main-font-size);

    flex-grow: 1;
    flex-shrink: 0;

    /* hack to make make it extremmely small on small screens */
    width: 1px;
    height: 100%;

    padding: unset;
    padding-left: 1px;
    padding-bottom: 3px;

    margin: unset;

    /* deal with application.css */
    border: unset;
    border-bottom: 1px solid var(--current-border-color);

    outline: none;

    transition: var(--border-transition);
  }

  .m-inline-search:focus-within {
    --current-border-color: var(--border-focused-color);
  }

  .m-inline-search__icon {
    color: var(--search-icon-color);

    flex-shrink: 0;

    width: 18px;
    height: 18px;

    padding-bottom: 2px;

    border-bottom: 1px solid var(--current-border-color);

    transition: var(--border-transition);
  }
</style>
